import { ChallengeFailure } from '../../challenge-failure';

export type IssueChallengeResponse = {
	id: string,
	challenge: string,
	difficulty: number,
	timeout: number,
	maxRetries: number,
	dryRun?: boolean,
}

export type IssueChallengeResult = IssueChallengeResponse | ChallengeFailure;

export type IssueChallengeAction = () => Promise<IssueChallengeResult>;
